import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row g-2 align-items-end" }
const _hoisted_4 = { class: "col-6 col-md-2" }
const _hoisted_5 = { class: "col-6 col-md-2" }
const _hoisted_6 = { class: "col-6 col-md-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-6 col-md-2 ms-auto" }
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col-12 table-responsive" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = { class: "table table-hover align-middle mb-0" }
const _hoisted_14 = { class: "nowrap-celular" }
const _hoisted_15 = { class: "nowrap-celular" }
const _hoisted_16 = { class: "nowrap-celular" }
const _hoisted_17 = { class: "text-nowrap" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "card-footer" }
const _hoisted_21 = { class: "row mt-1" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "col-md-2" }

import { onMounted, reactive } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Paginador from "@/components/Paginador/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownClientes from "@/components/Dropdowns/DropdownClientes.vue";

import * as service from "@/services/vouchersService";
import { fdata, f2dec } from "@/utils/funcoes";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const statusOpcoes = [
  { valor: null,                             descricao: "- Todos -" },
  { valor: service.eVoucherStatus.Pendente,  descricao: "Pendente"  },
  { valor: service.eVoucherStatus.Pago,      descricao: "Pago"      },
  { valor: service.eVoucherStatus.Cancelado, descricao: "Cancelado" },
];

function badgeStatus(status: service.eVoucherStatus) {
  if (status === service.eVoucherStatus.Pago)      return "badge-soft-success";
  if (status === service.eVoucherStatus.Cancelado) return "badge-soft-danger";
  return "badge-soft-warning";
}

function labelStatus(status: service.eVoucherStatus) {
  if (status === service.eVoucherStatus.Pago)      return "Pago";
  if (status === service.eVoucherStatus.Cancelado) return "Cancelado";
  return "Pendente";
}

const controle = reactive({
  filtros: {
    voucherId:   null,
    nome:        null,
    vendedorId:  null,
    indicadorId: null,
    indicadoId:  null,
    status:      null,
    paginaAtual: 1,
    tamanhoPagina: 15,
  } as service.Filtros,
  itens: [] as service.Voucher[],
  totalRegistros: 0,
  itemExcluir: null as service.Voucher | null,
  janExcluir: false,
  status: "",
  erro: "",
});

onMounted(() => pesquisar());

function pesquisar() {
  controle.status = "Carregando...";
  controle.erro   = "";
  service.obter(controle.filtros)
    .then(r => {
      controle.itens          = (r as any).dados ?? r;
      controle.totalRegistros = (r as any).totalRegistros ?? controle.itens.length;
      controle.status         = "";
    })
    .catch(e => { controle.status = ""; controle.erro = e.message || String(e); });
}

function pergExcluir(item: service.Voucher) {
  controle.itemExcluir = item;
  controle.janExcluir  = true;
}

function excluir() {
  if (!controle.itemExcluir) return;
  service.excluir(controle.itemExcluir.voucherId)
    .then(() => { controle.janExcluir = false; pesquisar(); })
    .catch(e => { controle.erro = e.message || String(e); controle.janExcluir = false; });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Vouchers" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Nome do indicado...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((controle.filtros.nome) = $event)),
              onKeyup: pesquisar
            }, null, 544), [
              [_vModelText, controle.filtros.nome]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Vendedor", -1)),
            _createVNode(DropdownVendedores, {
              modelValue: controle.filtros.vendedorId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((controle.filtros.vendedorId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.filtros.status) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOpcoes, (op, i) => {
                return _createElementVNode("option", {
                  key: i,
                  value: op.valor
                }, _toDisplayString(op.descricao), 9, _hoisted_7)
              }), 64))
            ], 544), [
              [_vModelSelect, controle.filtros.status]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-primary btn-sm float-end",
              to: "/vouchers/cadastro"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-plus" }, null, -1),
                _createTextVNode(" Adicionar ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (controle.erro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(controle.erro), 1))
              : _createCommentVNode("", true),
            (controle.status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(controle.status), 1))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_13, [
              _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "#"),
                  _createElementVNode("th", null, "Indicador (quem indicou)"),
                  _createElementVNode("th", null, "Indicado (novo cliente)"),
                  _createElementVNode("th", null, "Vendedor"),
                  _createElementVNode("th", null, "Valor"),
                  _createElementVNode("th", null, "Status"),
                  _createElementVNode("th", null, "Cadastro"),
                  _createElementVNode("th", null, "Pagamento"),
                  _createElementVNode("th", null, "Opções")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.itens, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.voucherId
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.voucherId), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.indicador?.nome ?? '—'), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.indicado?.nome  ?? '—'), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(item.vendedor?.nomeCompleto ?? '—'), 1),
                    _createElementVNode("td", null, "R$ " + _toDisplayString(_unref(f2dec)(item.valor)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", badgeStatus(item.status)])
                      }, _toDisplayString(labelStatus(item.status)), 3)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.dataCadastro ? _unref(fdata)(item.dataCadastro) : '—'), 1),
                    _createElementVNode("td", null, _toDisplayString(item.dataPagamento ? _unref(fdata)(item.dataPagamento) : '—'), 1),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_RouterLink, {
                        to: `/vouchers/cadastro/${item.voucherId}`,
                        title: "Editar",
                        class: "me-2"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]),
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        title: "Excluir",
                        onClick: ($event: any) => (pergExcluir(item))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "flaticon-delete fs-5 text-danger" }, null, -1)
                      ]))], 8, _hoisted_18)
                    ])
                  ]))
                }), 128)),
                (controle.itens.length === 0 && !controle.status)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("td", {
                        colspan: "9",
                        class: "text-center text-muted py-3"
                      }, "Nenhum registro encontrado.", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(controle.totalRegistros) + " Registros", 1),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: controle.filtros.paginaAtual,
              tamanhoPagina: controle.filtros.tamanhoPagina,
              totalRegistros: controle.totalRegistros,
              onOnChange: _cache[3] || (_cache[3] = (el) => {
              controle.filtros.paginaAtual    = el.paginaAtual;
              controle.filtros.tamanhoPagina  = el.tamanhoPagina;
              pesquisar();
            })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalRegistros"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: "/"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: "janExcluir",
      titulo: "Atenção",
      exibir: controle.janExcluir,
      onOnFechou: _cache[4] || (_cache[4] = ($event: any) => (controle.janExcluir = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[5] || (_cache[5] = ($event: any) => (excluir()))
    }, {
      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
        _createElementVNode("div", { class: "fw-bold fs-6" }, "Deseja excluir/cancelar este voucher?", -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})